import { Guid } from '@web/utils';
import { PaymentMethodCode } from '@web/shared/module/shop';

export class AdminPaymentMethod {
  public constructor(
    public readonly data: {
      id: Guid;
      code: PaymentMethodCode;
      name: string;
    },
  ) {}

  public get id(): Guid {
    return this.data.id;
  }

  public get code(): PaymentMethodCode {
    return this.data.code;
  }

  public get name(): string {
    return this.data.name;
  }
}
